import { render, staticRenderFns } from "./delete-user-document.vue?vue&type=template&id=32fae4d2&scoped=true&"
import script from "./delete-user-document.vue?vue&type=script&lang=js&"
export * from "./delete-user-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fae4d2",
  null
  
)

export default component.exports